import axios from 'axios';

export default {
    fetchAllSuppliers() {
        return axios.post('/supplier/list/');
    },
};
